module.exports = __webpack_public_path__ + "static/media/failed.bc5bc355.png";